/** Loading placeholder matching the card's layout to avoid layout shift. */
export const ProductCardSkeleton = () => (
  <div className="flex animate-pulse flex-col space-y-3">
    <div className="aspect-square rounded-lg bg-grey-100" />
    <div className="h-4 w-3/4 rounded bg-grey-100" />
    <div className="h-4 w-1/3 rounded bg-grey-100" />
  </div>
);
